import * as React from 'react';

import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from 'src/utils/shadcn';

function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
    return (
        <AvatarPrimitive.Root
            data-slot="avatar"
            className={cn('relative flex size-10 shrink-0 overflow-hidden rounded-full', className)}
            {...props}
        />
    );
}

function AvatarImage({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Image>) {
    return (
        <AvatarPrimitive.Image
            data-slot="avatar-image"
            className={cn('aspect-square size-full', className)}
            {...props}
        />
    );
}

function AvatarFallback({ className, children, ...props }: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
    const getInitials = (name: string) => {
        if (!name) return '';

        const names = name.split(' ');
        if (names.length === 1) return names[0][0].toLocaleUpperCase();
        else return names[0][0].toLocaleUpperCase() + names[names.length - 1][0].toLocaleUpperCase();
    };

    return (
        <AvatarPrimitive.Fallback
            data-slot="avatar-fallback"
            className={cn(
                'bg-muted text-primary flex size-full items-center justify-center rounded-full font-semibold',
                className,
            )}
            {...props}
        >
            {typeof children === 'string' ? getInitials(children) : children}
        </AvatarPrimitive.Fallback>
    );
}

export { Avatar, AvatarImage, AvatarFallback };
